// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"107":"fee01528","488":"0ab2fde0","614":"97268aca","678":"706bef4f"}[chunkId] + ".chunk.css";
};